const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;
const SCRIPT_ID = 'gtag-script';

const isBrowser = () => typeof window !== 'undefined';

const ensureGtag = () => {
  if (!isBrowser()) return false;
  const existing = window.gtag;
  if (existing) return true;
  const dataLayer = window.dataLayer || [];
  window.dataLayer = dataLayer;
  window.gtag = function gtag(...args) {
    window.dataLayer.push(args);
  };
  return true;
};

export const initAnalytics = () => {
  if (!GA_MEASUREMENT_ID || !isBrowser()) return;
  if (document.getElementById(SCRIPT_ID)) return;

  const script = document.createElement('script');
  script.id = SCRIPT_ID;
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
  document.head.appendChild(script);

  if (!ensureGtag()) return;
  window.gtag('js', new Date());
  window.gtag('config', GA_MEASUREMENT_ID, { send_page_view: false });
};

export const trackPageView = (path) => {
  if (!GA_MEASUREMENT_ID || !isBrowser() || typeof window.gtag !== 'function') return;
  window.gtag('config', GA_MEASUREMENT_ID, { page_path: path });
};
